module.exports = __webpack_public_path__ + "img/la-co-viet-nam.ccb5193c.png";